import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "user-menu-wrap" }
const _hoisted_2 = { class: "user-options" }
const _hoisted_3 = {
  key: 0,
  class: "user-quick-add"
}
const _hoisted_4 = {
  key: 1,
  class: "mobile-991"
}
const _hoisted_5 = { class: "seg seg-dark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = () => { _ctx.$store.state.showSubMenu = !_ctx.$store.state.showSubMenu }),
      class: "user-display"
    }, [...(_cache[8] || (_cache[8] = [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, [
        _createElementVNode("path", { d: "M19 7.001c0 3.865-3.134 7-7 7s-7-3.135-7-7c0-3.867 3.134-7.001 7-7.001s7 3.134 7 7.001zm-1.598 7.18c-1.506 1.137-3.374 1.82-5.402 1.82-2.03 0-3.899-.685-5.407-1.822-4.072 1.793-6.593 7.376-6.593 9.821h24c0-2.423-2.6-8.006-6.598-9.819z" })
      ], -1)
    ]))]),
    (_ctx.$store.state.user.firstName || _ctx.$store.state.user.companyName)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "user-display-name",
          onClick: _cache[1] || (_cache[1] = () => { _ctx.$store.state.showSubMenu = !_ctx.$store.state.showSubMenu })
        }, [
          _createElementVNode("strong", null, _toDisplayString([_ctx.$store.state.user.firstName, _ctx.$store.state.user.lastName].filter(Boolean).join(' ')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$store.state.user.companyName), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.$store.state.showSubMenu ? 'opacity: 1; pointer-events: auto;' : ''),
      class: "user-options-wrap"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$store.state.user.employeeID)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.quickAdd('task')), ["prevent"]))
              }, "Add Task"),
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.quickAdd('agenda')), ["prevent"]))
              }, "Add Agenda Item")
            ]))
          : _createCommentVNode("", true),
        (_ctx.$store.state.user.userToPublic)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  style: {"margin":"0"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchToAdmin())),
                  class: _normalizeClass(_ctx.$store.state.user.isAdmin ? 'on' : '')
                }, "Admin", 2),
                _createElementVNode("button", {
                  style: {"margin":"0"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.switchToPublic())),
                  class: _normalizeClass(_ctx.$store.state.user.isAdmin ? '' : 'on')
                }, "Standard", 2)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.$store.state.user.returnAdminID && !_ctx.$store.state.user.supportSession)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              onClick: _cache[6] || (_cache[6] = _withModifiers(() => { _ctx.$store.state.showChangePassword = true; }, ["prevent"]))
            }, "Change Password"))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.logOut()), ["prevent"]))
        }, "Log Out")
      ])
    ], 4)
  ]))
}